
/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
// Avoid patching unload, which can disable bfcache in some browsers.
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['unload'];
import 'zone.js';  // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */
